export const POSTS = "POSTS";
export const DELETE_POST = "DELETE_POST";
export const CREATE_POST = "CREATE_POST";
export const UPDATE_POST = "UPDATE_POST";
